import type { ReactNode } from 'react';
import type { Language } from '../../types';
import { _t } from '../../lib/i18n';
import { AppDialog } from './AppDialog';
import {
  formCancelButtonClass,
  formDestructiveButtonClass,
  formSaveButtonClass,
} from '../../styles/uiStandards';

export type ConfirmDialogProps = {
  open: boolean;
  lang: Language;
  title?: string;
  message: ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  destructive?: boolean;
  busy?: boolean;
  hideConfirm?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDialog({
  open,
  lang,
  title,
  message,
  confirmLabel,
  cancelLabel,
  destructive = false,
  busy = false,
  hideConfirm = false,
  onConfirm,
  onCancel,
}: ConfirmDialogProps) {
  return (
    <AppDialog
      open={open}
      title={title ?? _t('common.confirmTitle', lang)}
      maxWidthClass="max-w-sm"
      footer={
        <>
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className={formCancelButtonClass}
          >
            {cancelLabel ?? _t('common.cancel', lang)}
          </button>
          {hideConfirm ? null : (
            <button
              type="button"
              onClick={onConfirm}
              disabled={busy}
              className={destructive ? formDestructiveButtonClass : formSaveButtonClass}
            >
              {confirmLabel ?? _t('common.confirm', lang)}
            </button>
          )}
        </>
      }
    >
      <div className="whitespace-pre-line text-sm leading-relaxed text-[var(--text-primary)]">{message}</div>
    </AppDialog>
  );
}
